import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { nebankaOcpRoute } from '../NebankaOcpParentPage/route';

export const nebankaOcpAccountTransactionsRoute = createRoute({
	path: '/transaction-history/$nomineeAccountId',
	getParentRoute: () => nebankaOcpRoute,
	component: lazyRouteComponent(
		() => import('./NebankaOcpAccountTransactionsPage'),
		'NebankaOcpAccountTransactionsPage',
	),
	validateSearch: z.object({
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	}),
});
